"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventNameCondition = exports.getEmailEventEmailIdConditionIndex = exports.getEmailEventEmailIdCondition = exports.getEmailEventCondition = exports.getPageviewEventURLCondition = exports.checkIsEmailEvent = exports.checkIsPageviewEvent = exports.archivedPeopleSegmentId = void 0;
const _ = require("lodash");
exports.archivedPeopleSegmentId = 1;
const checkIsPageviewEvent = (event) => {
    var _a;
    return Boolean(_.find((_a = event.systemConditions) === null || _a === void 0 ? void 0 : _a.conditions, (condition) => condition.type === "field" &&
        condition.field === "type" &&
        condition.condition === "is" &&
        condition.value === "page"));
};
exports.checkIsPageviewEvent = checkIsPageviewEvent;
const checkIsEmailEvent = (event) => {
    var _a;
    return Boolean(_.find((_a = event.systemConditions) === null || _a === void 0 ? void 0 : _a.conditions, (condition) => condition.type === "field" &&
        condition.field === "type" &&
        condition.condition === "is" &&
        condition.value === "email"));
};
exports.checkIsEmailEvent = checkIsEmailEvent;
const getPageviewEventURLCondition = (conditions) => {
    const condition = _.find(conditions, (current) => current.type === "field" && current.field === "url");
    return condition;
};
exports.getPageviewEventURLCondition = getPageviewEventURLCondition;
const getEmailEventCondition = (conditions) => {
    return _.find(conditions, (current) => current.type === "field" &&
        current.field === "name" &&
        current.condition === "is");
};
exports.getEmailEventCondition = getEmailEventCondition;
const getEmailEventEmailIdCondition = (conditions) => {
    const conditionIndex = (0, exports.getEmailEventEmailIdConditionIndex)(conditions);
    if (conditionIndex === -1)
        return undefined;
    return conditions[conditionIndex];
};
exports.getEmailEventEmailIdCondition = getEmailEventEmailIdCondition;
const getEmailEventEmailIdConditionIndex = (conditions) => _.findIndex(conditions, (condition) => condition.type === "field" &&
    condition.field === "data.emailId" &&
    condition.condition === "is");
exports.getEmailEventEmailIdConditionIndex = getEmailEventEmailIdConditionIndex;
const getEventNameCondition = (event) => {
    return _.find(event.systemConditions.conditions, (propertyCondition) => (propertyCondition === null || propertyCondition === void 0 ? void 0 : propertyCondition.type) === "field" && (propertyCondition === null || propertyCondition === void 0 ? void 0 : propertyCondition.field) === "name");
};
exports.getEventNameCondition = getEventNameCondition;
//# sourceMappingURL=segment.js.map